import { Component, contentChild, contentChildren, Directive, input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';


@Directive({
  selector: '[contentPlaceholder]',
  standalone: true
})
export class ContentPlaceholderDirective { }


@Directive({
  selector: '[contentEmpty]',
  standalone: true
})
export class ContentEmptyDirective { }


@Directive({
  selector: '[contentFooter]',
  standalone: true
})
export class ContentFooterDirective { }


@Directive({
  selector: '[contentLoading]',
  standalone: true
})
export class ContentLoadingDirective { }


@Directive({
  selector: '[contentList]',
  standalone: true
})
export class ContentListDirective<T> {
  headerTemplate = input<TemplateRef<any> | null>();
  itemTemplate = input<TemplateRef<any> | null>();
  items = input<T[] | null>();
  backgroundColor = input<string | undefined>();
}


@Component({
  selector: 'content-panel',
  standalone: true,
  imports: [
    NgTemplateOutlet
  ],
  templateUrl: './content-panel.component.html',
  styleUrl: './content-panel.component.scss'
})
export class ContentPanelComponent {
  placeholderTemplate = contentChild(ContentPlaceholderDirective, {read: TemplateRef});
  emptyTemplate = contentChild(ContentEmptyDirective, {read: TemplateRef});
  footerTemplate = contentChild(ContentFooterDirective, {read: TemplateRef});
  loadingTemplate = contentChild(ContentLoadingDirective, {read: TemplateRef});
  contentLists = contentChildren(ContentListDirective);
  itemsCount = input<number | null>();
  loading = input<boolean>(false);
}
